export default <svg aria-hidden='true' width='126' height='73' viewBox='0 0 126 73' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M53 49.9782V22.575C53 21.0113 54.7139 20.0524 56.0465 20.8707L78.684 34.7709C79.9649 35.5574 79.9529 37.4228 78.662 38.1928L56.0246 51.6959C54.6914 52.4911 53 51.5305 53 49.9782Z' fill='white'/>
  <rect x='1' y='1' width='124' height='71' rx='35.5' stroke='white' strokeWidth='2'/>
</svg>
